export const MAXIMUM_SELECTED_DATERANGE = 31;
export const MAXIMUM_LOOKBACK_DAYS = 90;

export const idsCsv = {
  email: 'email',
  maxWeeklyHours: 'maxWeeklyHours',
  onlyId: 'onlyId',
  onlyName: 'onlyName',
  phone: 'phone',
  team: 'team',
};
